import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PromoEntity } from '@promo/const';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { PromoActions } from '../actions';
import { StateWithPromo } from '../promo-state';
import { PromoSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class PromoService {
  constructor(private store: Store<StateWithPromo>) {}

  loadPromo(baseStoreCode: string): void {
    this.store.dispatch(new PromoActions.PromoLoad(baseStoreCode));
  }

  getPromoState(): Observable<StateUtils.LoaderState<PromoEntity>> {
    return this.store.select(PromoSelectors.getPromoState);
  }

  getPromo(): Observable<PromoEntity> {
    return this.store.select(PromoSelectors.getPromoValue);
  }

  getPromoLoading(): Observable<boolean> {
    return this.store.select(PromoSelectors.getPromoLoading);
  }

  getPromoError(): Observable<boolean> {
    return this.store.select(PromoSelectors.getPromoError);
  }

  getPromoSuccess(): Observable<boolean> {
    return this.store.select(PromoSelectors.getPromoSuccess);
  }
}
